import React, { memo } from "react";
import { HelpRounded, StarBorder } from "@mui/icons-material";
import Divider from "../components/Divider";
import { TextGray } from "../ProductDetail.styles";
import { useTheme } from "styled-components";
import Box from "component/layoutComponents/Box";
import Rating from "component/commonComponents/Rating";
import DefaultUptimeTheme from "component/theme/defaultTheme";
import EyeBrow from "component/MarketPlace/eyeBrow/eyeBrow";
import { useProductEyebrow } from "component/MarketPlace/ProductCard/hooks/useProductEyebrow";
import { Tooltip } from "@mui/material";
import { TruncatedText } from "component/MarketPlace/Typography/Typography.style";

const HeaderContent = ({
  modelManufacturer,
  productName,
  eyeBrowText = '',
  showRating = true,
  locale = {},
  reasonText = ''
}: {
  modelManufacturer: string | undefined;
  productName: string | undefined;
  eyeBrowText?: string;
  showRating?: boolean;
  locale?: any;
  reasonText?: any;
}) => {
  const theme = useTheme() as unknown as typeof DefaultUptimeTheme;
  const eyebrow = useProductEyebrow(eyeBrowText, locale?.commonStatus);

  return (
    <>
      <Box margin={`${theme.uptimeSpace[8]}px 0`}>
        <TextGray variant="overline" color="text.secondary">
          {modelManufacturer?.toUpperCase()}
        </TextGray>
      </Box>
      <TruncatedText
        color="text.primary"
        maxlines={1}
        variant="h2"
        gutterBottom={false}
        fontSize={{ 
          xs: `${theme.uptimeFontSizes.desktop.fz11}px`,
          sm: `${theme.uptimeFontSizes.desktop.fz13}px` 
        }}
      >
        {productName}
      </TruncatedText>
      <Box marginTop="16px" display="flex" alignItems="center">
        {eyebrow.text && (
          <>
            <EyeBrow
              color="primary"
              label={eyebrow.text}
              size="small"
              endIcon={
                <Tooltip title={reasonText} arrow placement="top">
                  <HelpRounded
                    sx={{ margin: '0 !important' }}
                  />
                </Tooltip> 
              }
              sx={{
                backgroundColor: eyebrow.color.background,
                color: eyebrow.color.color,
                fontWeight: 600,
                textTransform: 'uppercase',
              }}
              variant="filled"
              onDelete={()=>{}}
            />
          </>
        )}
        {eyeBrowText && showRating && <Divider padding={`${theme.uptimeSpace[0]}px ${theme.uptimeSpace[4]}px`} />}
        {showRating && (
          <Rating
            readOnly
            value={2}
            defaultValue={0}
            precision={0.5}
            emptyIcon={<StarBorder fontSize="inherit" />}
          />
        )}
      </Box>
    </>
  );
};

export default memo(HeaderContent);
